import React from "react"

import FreePlanQuotaNotification from "./FreePlanQuotaNotification"
import SideNavigation from "./SideNavigation"

type SettingsChild = {
  title: string
  href: string
  active: boolean
  hint?: string
}

type SettingsItem = {
  title: string
  href: string | null
  icon: string
  id?: string | null
  active: boolean
  children: SettingsChild[]
  open?: boolean
  nonLink?: boolean
}

export type SettingsNavigationData = {
  kind: "account" | "app" | "organization"
  organizationSlug?: string
  back: { title: string; href: string; icon: string }
  items: SettingsItem[]
  freePlanUsage: { organizationSlug: string } | null
}

const SettingsItemView = ({ item, back = false }: { item: SettingsItem; back?: boolean }) => {
  const type = item.href === null && !item.nonLink ? "menu" : "link"

  return (
    <SideNavigation.Item
      type={type}
      id={item.id ?? undefined}
      title={item.title}
      href={item.href ?? undefined}
      iconClassName={item.icon}
      color={back ? undefined : "blue"}
      active={item.active}
      open={item.open ?? false}
      nonLink={item.nonLink}
    >
      {item.children.map((child) => (
        <SideNavigation.Item key={`${child.title}-${child.href}`} type="subitem" {...child} />
      ))}
    </SideNavigation.Item>
  )
}

const SettingsNavigation = ({ kind, organizationSlug, back, items, freePlanUsage }: SettingsNavigationData) => {
  const heading = {
    account: "Account settings",
    app: "App settings",
    organization: "Org settings",
  }[kind]

  return (
    <SideNavigation
      organizationSlug={organizationSlug}
      footerItems={
        freePlanUsage && (
          <li className="c-side-nav__section">
            <FreePlanQuotaNotification organizationSlug={freePlanUsage.organizationSlug} enabled />
          </li>
        )
      }
    >
      <h3 className="sr-only">{heading}</h3>
      <SideNavigation.List>
        <SettingsItemView item={{ ...back, active: false, children: [] }} back />
        {items.map((item, index) => (
          <SettingsItemView key={`${item.title}-${index}`} item={item} />
        ))}
      </SideNavigation.List>
    </SideNavigation>
  )
}

export default SettingsNavigation
